import React from "react";
import background1 from "../assets/images/slidder3.jpg";

const QuiSommesNous: React.FC = () => {
  return (
    <>
      {/* HERO SECTION */}
      <div
        className="w-full min-h-[320px] sm:min-h-[380px] md:min-h-[450px] bg-cover bg-center relative flex items-center justify-start px-4 sm:px-10 md:px-16 lg:px-24 py-10"
        style={{
          backgroundImage: `url(${background1})`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>

<div className="relative text-left sm:text-left text-white w-full max-w-3xl space-y-5">
          <span className="text-blue-300 text-sm tracking-widest uppercase">
            À propos de J-Tronics
          </span>

          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold leading-tight">
            Qui sommes-nous ?
          </h2>

          <p className="text-sm sm:text-base text-gray-200 max-w-xl">
            Découvrez notre entreprise, notre vision et notre engagement dans les solutions de lavage innovantes.
          </p>

<div className="flex flex-col sm:flex-row gap-4 pt-2 w-full sm:w-auto">

            <a
              href="/"
              className="group flex items-center justify-center gap-3 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 shadow-lg hover:shadow-blue-500/40 hover:scale-105"
            >
              Accueil
            </a>

            <a
              href="/contact"
              className="group flex items-center justify-center gap-3 border-2 border-yellow-400 hover:bg-blue-600 hover:border-blue-600 text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 shadow-lg hover:shadow-blue-500/40 hover:scale-105"
            >
              Contactez-nous
            </a>

          </div>
        </div>
      </div>

      {/* ===================== À PROPOS DE NOUS ===================== */}
      <div className="relative bg-white overflow-hidden">
        {/* watermark décoratif */}
        <span className="pointer-events-none select-none absolute -top-6 left-1/2 -translate-x-1/2 text-[22vw] md:text-[14rem] font-black text-gray-50 leading-none tracking-tight whitespace-nowrap z-0">
          J-TRONICS
        </span>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 pt-16 md:pt-20 pb-16 z-10">

<div className="grid grid-cols-1 lg:grid-cols-[260px_1fr] gap-10 lg:gap-16 items-start">
            {/* Colonne titre sticky */}
<div className="lg:sticky lg:top-24 lg:self-start text-center lg:text-left">
                <span className="inline-flex items-center gap-2 text-blue-600 text-xs font-bold tracking-[0.2em] uppercase mb-4">
                <span className="w-8 h-px bg-yellow-400"></span>
                Notre entreprise
              </span>
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 leading-[1.05]">
                À propos
                <span className="block text-blue-600">de nous</span>
              </h1>
              <div className="hidden lg:block mt-6 h-1.5 w-16 bg-gradient-to-r from-yellow-400 to-blue-600 rounded-full"></div>
            </div>

            {/* Colonne texte */}
            <div className="space-y-6">
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed border-l-4 border-yellow-400 pl-5">
                J-Tronics est une entreprise tunisienne spécialisée dans la conception et le développement de solutions de lavage. Depuis sa création, l’entreprise s’est construite autour d’une vision claire visant à moderniser l’expérience du lavage grâce à des équipements fiables, performants et faciles à utiliser.
              </p>

              <p className="text-base md:text-lg text-gray-600 leading-relaxed">
                Implantée à Djebeniana, J-Tronics s’appuie sur une expertise technique solide et une approche orientée innovation pour concevoir des systèmes adaptés aux exigences du marché. Chaque solution est pensée pour optimiser la performance, réduire les coûts d’exploitation et garantir une utilisation intuitive.
              </p>

              <p className="text-base md:text-lg text-gray-600 leading-relaxed">
                Au-delà de la fabrication, J-Tronics accompagne ses clients dans la mise en place de leurs projets, en assurant un suivi technique et un engagement constant envers la qualité et la satisfaction.
              </p>
            </div>
          </div>

          {/* BANDE SPECS - Coût / Qualité / Sécurité / Délais */}
          <div className="mt-20 rounded-3xl bg-gradient-to-br from-blue-700 via-blue-700 to-blue-900 shadow-2xl shadow-blue-900/30 overflow-hidden">
<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 divide-blue-500/30 lg:divide-x text-center sm:text-left">
              {/* Coût optimisé des projets */}
<div className="group p-6 sm:p-7 md:p-8 hover:bg-white/5 transition-colors duration-300">
                <div className="w-12 h-12 rounded-xl bg-yellow-400 flex items-center justify-center mb-5 group-hover:-translate-y-1 transition-transform duration-300">
                  <svg className="w-6 h-6 text-blue-900" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <path d="M17 5.5H9.5C8.12 5.5 7 6.62 7 8C7 9.38 8.12 10.5 9.5 10.5H14.5C15.88 10.5 17 11.62 17 13C17 14.38 15.88 15.5 14.5 15.5H6.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <h2 className="text-lg font-bold text-white mb-2">
                  Coût optimisé des projets
                </h2>
                <p className="text-blue-100/80 text-sm leading-relaxed">
                  Nous concevons des solutions performantes en optimisant les ressources afin d’offrir le meilleur rapport qualité/prix à nos clients.
                </p>
              </div>

              {/* Qualité et conformité */}
              <div className="group p-7 sm:p-8 hover:bg-white/5 transition-colors duration-300">
                <div className="w-12 h-12 rounded-xl bg-yellow-400 flex items-center justify-center mb-5 group-hover:-translate-y-1 transition-transform duration-300">
                  <svg className="w-6 h-6 text-blue-900" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 12L11 14L15 9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M12 3L19 6V11.5C19 16 16 19 12 21C8 19 5 16 5 11.5V6L12 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <h2 className="text-lg font-bold text-white mb-2">
                  Qualité et conformité
                </h2>
                <p className="text-blue-100/80 text-sm leading-relaxed">
                  Nos équipements respectent des standards de qualité élevés garantissant fiabilité, durabilité et performance dans le temps.
                </p>
              </div>

              {/* Sécurité des installations */}
              <div className="group p-7 sm:p-8 hover:bg-white/5 transition-colors duration-300">
                <div className="w-12 h-12 rounded-xl bg-yellow-400 flex items-center justify-center mb-5 group-hover:-translate-y-1 transition-transform duration-300">
                  <svg className="w-6 h-6 text-blue-900" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 22C12 22 20 18 20 11V5L12 2L4 5V11C4 18 12 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M12 8V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <circle cx="12" cy="16" r="0.9" fill="currentColor" />
                  </svg>
                </div>
                <h2 className="text-lg font-bold text-white mb-2">
                  Sécurité des installations
                </h2>
                <p className="text-blue-100/80 text-sm leading-relaxed">
                  Chaque système est conçu avec des protocoles de sécurité stricts pour assurer une utilisation fiable et sans risque.
                </p>
              </div>

              {/* Délais de réalisation maîtrisés */}
              <div className="group p-7 sm:p-8 hover:bg-white/5 transition-colors duration-300">
                <div className="w-12 h-12 rounded-xl bg-yellow-400 flex items-center justify-center mb-5 group-hover:-translate-y-1 transition-transform duration-300">
                  <svg className="w-6 h-6 text-blue-900" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="13" r="8" stroke="currentColor" strokeWidth="2" />
                    <path d="M12 9V13L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9 2H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <path d="M19 4L17.5 5.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </div>
                <h2 className="text-lg font-bold text-white mb-2">
                  Délais de réalisation maîtrisés
                </h2>
                <p className="text-blue-100/80 text-sm leading-relaxed">
                  Grâce à des processus optimisés et une technologie moderne, nous réduisons les délais d’installation tout en maintenant un haut niveau de qualité.
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* ===================== NOS VALEURS ET ENGAGEMENTS ===================== */}
      <div className="relative bg-gray-50 py-20 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">

          <div className="flex flex-col items-center text-center mb-14">
            <span className="text-yellow-500 text-xs font-bold tracking-[0.2em] uppercase mb-3">
              Ce qui nous définit
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 mb-5">
              Nos valeurs et <span className="text-blue-600">engagements</span>
            </h2>
            <div className="h-1.5 w-20 bg-gradient-to-r from-yellow-400 to-blue-600 rounded-full mb-6"></div>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed max-w-3xl">
              Chez J-Tronics, nos principes fondamentaux guident chacune de nos décisions et de nos réalisations. Ils reflètent notre engagement envers l’innovation, la qualité et la satisfaction de nos clients dans le domaine des solutions de lavage.
            </p>
          </div>

          {/* CARDS */}
<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {/* Principes directeurs */}
            <div className="group relative bg-white rounded-2xl p-7 shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 overflow-hidden border-t-4 border-blue-600">
              <div className="absolute -bottom-8 -right-8 w-28 h-28 bg-blue-50 rounded-full group-hover:scale-150 transition-transform duration-500"></div>
              <div className="relative">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center shadow-lg shadow-blue-600/30 mb-5 group-hover:scale-110 group-hover:-rotate-3 transition-transform duration-300">
                  <svg className="w-7 h-7 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 21C12 21 4 16.5 4 10.5C4 7.5 6.2 5.5 8.8 5.5C10.2 5.5 11.3 6.1 12 7.1C12.7 6.1 13.8 5.5 15.2 5.5C17.8 5.5 20 7.5 20 10.5C20 16.5 12 21 12 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">
                  Principes directeurs
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  L’intégrité, l’innovation et la satisfaction client sont au cœur de notre entreprise. Elles définissent notre manière de concevoir, produire et accompagner nos solutions.
                </p>
              </div>
            </div>

            {/* Satisfaction de nos partenaires */}
            <div className="group relative bg-white rounded-2xl p-7 shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 overflow-hidden border-t-4 border-yellow-400">
              <div className="absolute -bottom-8 -right-8 w-28 h-28 bg-yellow-50 rounded-full group-hover:scale-150 transition-transform duration-500"></div>
              <div className="relative">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-yellow-400 to-yellow-500 flex items-center justify-center shadow-lg shadow-yellow-400/30 mb-5 group-hover:scale-110 group-hover:-rotate-3 transition-transform duration-300">
                  <svg className="w-7 h-7 text-blue-900" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="9" cy="8" r="3" stroke="currentColor" strokeWidth="2" />
                    <path d="M3 20C3 16.5 5.5 14.5 9 14.5C12.5 14.5 15 16.5 15 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M15.5 6.5C16.9 6.8 18 8 18 9.5C18 11 16.9 12.2 15.5 12.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <path d="M16.5 14.8C19.2 15.4 21 17.2 21 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">
                  Satisfaction de nos partenaires
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Nous plaçons nos clients et partenaires au centre de nos priorités en assurant une écoute active, un suivi régulier et une réponse adaptée à leurs besoins spécifiques.
                </p>
              </div>
            </div>

            {/* Qualité */}
            <div className="group relative bg-white rounded-2xl p-7 shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 overflow-hidden border-t-4 border-blue-600">
              <div className="absolute -bottom-8 -right-8 w-28 h-28 bg-blue-50 rounded-full group-hover:scale-150 transition-transform duration-500"></div>
              <div className="relative">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center shadow-lg shadow-blue-600/30 mb-5 group-hover:scale-110 group-hover:-rotate-3 transition-transform duration-300">
                  <svg className="w-7 h-7 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 3L14.5 8.2L20.2 9L16.1 13L17.1 18.8L12 16L6.9 18.8L7.9 13L3.8 9L9.5 8.2L12 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">
                  Qualité
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Nous nous engageons à fournir des équipements fiables, performants et durables, répondant aux standards les plus élevés du secteur du lavage.
                </p>
              </div>
            </div>

            {/* Innovation */}
            <div className="group relative bg-white rounded-2xl p-7 shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 overflow-hidden border-t-4 border-yellow-400">
              <div className="absolute -bottom-8 -right-8 w-28 h-28 bg-yellow-50 rounded-full group-hover:scale-150 transition-transform duration-500"></div>
              <div className="relative">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-yellow-400 to-yellow-500 flex items-center justify-center shadow-lg shadow-yellow-400/30 mb-5 group-hover:scale-110 group-hover:-rotate-3 transition-transform duration-300">
                  <svg className="w-7 h-7 text-blue-900" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <path d="M10 21H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <path d="M12 3C8.5 3 6.5 5.5 6.5 8.5C6.5 11 8 12.2 8.7 13.5C9.2 14.4 9.3 15 9.3 16H14.7C14.7 15 14.8 14.4 15.3 13.5C16 12.2 17.5 11 17.5 8.5C17.5 5.5 15.5 3 12 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">
                  Innovation
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Nous développons continuellement des solutions modernes et intelligentes afin d’améliorer l’efficacité, la simplicité et la performance de nos systèmes.
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default QuiSommesNous;